import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import Footer from "./Footer";
import "../../assets/scss/app.scss";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { toast, ToastContainer } from "react-toastify";

const EmailConfigComponent = ({ title, label, query, formHelp, inputType }) => {
  const [adminEmail, setAdminEmail] = useState("");
  const [saveAdminLoading, setSaveAdminLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postResponseAdminRole, setPostResponseAdminEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin.request(`/settings/${query}`, {
          method: "get",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
          params: {
            // ...data
          },
        });
        setResponseData(response.data);
        setAdminEmail(response.data.value);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleTextChange = (event) => {
    setAdminEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveAdminLoading(true);
    setError(null);
    const requestData = {
      value: adminEmail,
    };
    // console.log("some data", checkedIds, roleName)
    try {
      const response = await scAxiosAdmin.post(
        `/settings_update/${query}`,
        requestData,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        }
      );
      setPostResponseAdminEmail(response.data);
      setSaveAdminLoading(false);
      toast.success("Admin Emails Updated Successfully!");
    } catch (err) {
      setError(err);
      setSaveAdminLoading(false);
    }
  };
  return (
    <div className="page-content-wrapper" style={{ margin: 0 }}>
      <div className="header-bg">
        <div className="container-fluid">
          <div className="d-flex pt-5">
            <h4>{title}</h4>
          </div>
        </div>
      </div>

      <div className="header-bg">
        <div className="container-fluid">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              {/* <label htmlFor="textInput">{label}</label> */}
              {
                (inputType == "textarea") ?
                  (<textarea className="form-control" id="textInput" placeholder={label} value={adminEmail} onChange={handleTextChange} />)
                  :
                  (<input
                    type="text"
                    className="form-control"
                    id="textInput"
                    // placeholder="Admin Email"
                    placeholder={label}
                    value={adminEmail}
                    onChange={handleTextChange}
                  />)
              }
            </div>
            {formHelp ? (
              <div className="">
                <small>{formHelp}</small>
                <br />
                <br />
              </div>
            ) : (
              ""
            )}

            <div className="form-group text-right">
              <button type="submit" className="btn btn-primary">
                {saveAdminLoading ? "Saving..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EmailConfigComponent;



// WEBPACK FOOTER //
// ./src/component/admin/EmailConfigComponent.js